import { GlobalStoreStateConfiguration } from '@/stores/globalStore';
import { fuelType } from '@/modules/constants/fuelType';
import {
  configurationsContainsFuelType,
  getModelTrim,
} from '@/modules/utils/storeUtils';
import { useTribalContext } from '@/context/tribal';

const EmissionsTsAndCs = ({
  configuration,
}: {
  configuration: GlobalStoreStateConfiguration;
}) => {
  const { contentManager } = useTribalContext();
  const currentDate = new Date().toLocaleDateString('en-GB');

  const containsDieselCar = configurationsContainsFuelType(fuelType.DIESEL, [
    configuration,
  ]);

  const containsPetrolCar = configurationsContainsFuelType(fuelType.PETROL, [
    configuration,
  ]);

  const containsHybridCar = configurationsContainsFuelType(fuelType.HYBRID, [
    configuration,
  ]);

  const containsElectricCar = configurationsContainsFuelType(
    fuelType.ELECTRIC,
    [configuration]
  );

  const containsPlugInHybridCar = configurationsContainsFuelType(
    fuelType.PLUG_IN_HYBRID,
    [configuration]
  );

  const modelDerivative = getModelTrim(
    configuration.modelTitle,
    configuration.pdbData?.derivative?.title
  );

  return (
    <>
      {(containsPetrolCar || containsDieselCar || containsHybridCar) && (
        <p>
          <strong>{modelDerivative}</strong>{' '}
          {contentManager.getParsedString(
            'petrol-diesel-emissions-terms-and-conditions',
            [
              {
                identifier: 'date',
                value: currentDate,
              },
            ]
          )}
        </p>
      )}
      {containsElectricCar && (
        <p>
          <strong>{modelDerivative}</strong>{' '}
          {contentManager.getParsedString(
            'electric-emissions-terms-and-conditions',
            [
              {
                identifier: 'date',
                value: currentDate,
              },
            ]
          )}
        </p>
      )}
      {containsPlugInHybridCar && (
        <p>
          <strong>{modelDerivative}</strong>{' '}
          {contentManager.getParsedString(
            'hybrid-emissions-terms-and-conditions',
            [
              {
                identifier: 'date',
                value: currentDate,
              },
            ]
          )}
        </p>
      )}
    </>
  );
};

export default EmissionsTsAndCs;
